export const POST_CSV_DEFAULT_COLUMNS = [
	'recipientName',
	'companyName',
	'street',
	'postal',
	'city',
	'status',
	'sentAt',
	'qrScanAt',
];

export const POST_CSV_COLUMN_GROUPS = {
	letter: {
		label: 'Briefdaten',
		columns: [
			{ key: 'recipientName', label: 'Empfänger' },
			{ key: 'street', label: 'Straße' },
			{ key: 'postal', label: 'PLZ' },
			{ key: 'city', label: 'Ort' },
			{ key: 'country', label: 'Land' },
			{ key: 'status', label: 'Status' },
			{ key: 'atPrinterAt', label: 'Beim Drucker am' },
			{ key: 'printedAt', label: 'Gedruckt am' },
			{ key: 'sentAt', label: 'Bei der Post am' },
			{ key: 'qrScanAt', label: 'QR gescannt am' },
			{ key: 'errorMessage', label: 'Fehlermeldung' },
		],
	},
	contact: {
		label: 'Kontaktdaten',
		columns: [
			{ key: 'contactId', label: 'Kontakt-ID' },
			{ key: 'contactName', label: 'Kontakt Name' },
			{ key: 'contactRole', label: 'Kontakt Position' },
			{ key: 'email', label: 'E-Mail' },
			{ key: 'phone', label: 'Telefon' },
		],
	},
	company: {
		label: 'Firmendaten',
		columns: [
			{ key: 'companyId', label: 'Unternehmens-ID' },
			{ key: 'companyName', label: 'Firmenname' },
			{ key: 'website', label: 'Website' },
		],
	},
};
